import { Component } from '@angular/core';
import { AuthService } from '../../../shared/services/auth.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: [ './navbar.component.css' ]
})
export class NavbarComponent {

  constructor (
    private readonly authService: AuthService,
  ) {
  }
  name = '';
  greeting = '';
  ngOnInit(): void {
    this.authService.userSubject.subscribe((res) => {
      this.name = res.name;
      if (!this.name) {
        var json = localStorage.getItem('userName') || '';
       this.name = JSON.parse(json);
      }
    });

    let today = new Date();
    let curHr = today.getHours();
    if (curHr < 12) {
      this.greeting = 'Good Morning';
    }
    else if (curHr < 18) {
      this.greeting = 'Good Afternoon';
    }
    else {
      this.greeting = 'Good Evening';
    }

  }
}
